import { render, staticRenderFns } from "./leftNavBar.vue?vue&type=template&id=2065eb22&scoped=true&"
import script from "./leftNavBar.vue?vue&type=script&lang=js&"
export * from "./leftNavBar.vue?vue&type=script&lang=js&"
import style0 from "./leftNavBar.vue?vue&type=style&index=0&id=2065eb22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2065eb22",
  null
  
)

export default component.exports